import { ApiService } from 'services/api'

type CancelTransactionParams = {
  id: string
  message: string
  isReversePayment?: boolean
  returned_value?: number
}

type usePagseguroResponse = {
  cancelTransaction: (
    params: CancelTransactionParams,
  ) => Promise<PagseguroCancelTransactionResponse>
  cancelActivity: (
    params: CancelTransactionParams,
  ) => Promise<PagseguroCancelTransactionResponse>
}

export default function usePagseguro(): usePagseguroResponse {
  const cancelTransaction = async ({
    id,
    message,
    isReversePayment = true,
    returned_value,
  }: CancelTransactionParams): Promise<PagseguroCancelTransactionResponse> => {
    const cancelResponse = await ApiService.Pagseguro.cancelTransaction({
      id,
      message,
      isReversePayment,
      returned_value,
    })
    return cancelResponse
  }

  const cancelActivity = async ({
    id,
    message,
    isReversePayment = true,
    returned_value,
  }: CancelTransactionParams): Promise<PagseguroCancelTransactionResponse> => {
    const cancelResponse = await ApiService.Pagseguro.cancelActivity({
      id,
      message,
      isReversePayment,
      returned_value,
    })
    return cancelResponse
  }

  return {
    cancelTransaction,
    cancelActivity,
  }
}
